import { FormType } from 'FormsUI/components/dashboard/frameworkTable/types';
import EmbedVersions from 'forms-utils-lib/constants/formDefinition/EmbedVersions';
export const FORM_OBJECT_TYPE = '0-28';
export const SPAM_SUBMISSIONS_OBJECT_TYPE = '0-105';
export const PROPERTIES = {
  FORM_ID: 'hs_form_id',
  FORM_TYPE: 'hs_form_type',
  NAME: 'hs_name',
  STATUS: 'hs_status',
  BUSINESS_UNIT_IDS: 'hs_all_assigned_business_unit_ids',
  LAST_MODIFIED_DATE: 'hs_lastmodifieddate',
  CREATED_AT: 'hs_created_at',
  UPDATED_AT: 'hs_updated_at',
  // Rollup properties
  VIEWS: 'hs_page_views',
  SUBMISSION_RATE: 'hs_form_submissions_per_page_view',
  SUBMISSIONS: 'hs_form_submissions',
  SPAM_SUBMISSIONS: 'hs_spam_submissions',
  FOLDER_ID: 'hs_folder_id',
  DELETABLE: 'hs_deletable',
  CLONEABLE: 'hs_cloneable',
  EDITABLE: 'hs_editable',
  // Empty properties
  CREATED_BY_USER_ID: 'hs_created_by_user_id',
  UPDATED_BY_USER_ID: 'hs_updated_by_user_id',
  HUBSPOT_OWNER_ASSIGNEDDATE: 'hubspot_owner_assigneddate',
  HUBSPOT_OWNER_ID: 'hubspot_owner_id',
  HUBSPOT_TEAM_ID: 'hubspot_team_id',
  HUBSPOT_ALL_TEAM_IDS: 'hs_all_team_ids',
  HUBSPOT_MERGED_OBJECT_IDS: 'hs_merged_object_ids',
  // Meta properties
  EMBED_VERSION: 'hs_embed_version'
};
export const DEFAULT_COLUMN_KEYS = [PROPERTIES.NAME, PROPERTIES.VIEWS, PROPERTIES.SUBMISSION_RATE, PROPERTIES.SPAM_SUBMISSIONS, PROPERTIES.SUBMISSIONS, PROPERTIES.BUSINESS_UNIT_IDS, PROPERTIES.FORM_ID, PROPERTIES.UPDATED_AT];
export const MANUALLY_EXCLUDED_COLUMNS = [PROPERTIES.LAST_MODIFIED_DATE, PROPERTIES.HUBSPOT_OWNER_ASSIGNEDDATE, PROPERTIES.HUBSPOT_OWNER_ID, PROPERTIES.HUBSPOT_TEAM_ID, PROPERTIES.HUBSPOT_MERGED_OBJECT_IDS];
export const DEFAULT_TABLE_COLUMN_SIZES = {
  width: 100,
  minWidth: 100,
  minResizeWidth: 100
};
export const TABLE_FORM_TYPES = [FormType.CAPTURED, FormType.HUBSPOT, FormType.FLOW, FormType.BLOG_COMMENT];
export const FORM_TYPE_SELECT_OPTIONS = [EmbedVersions.V3, EmbedVersions.V4, FormType.CAPTURED, FormType.FLOW, FormType.BLOG_COMMENT];
export const MAX_ROWS_ABOVE_PQL_ROW = 2;
export const SCROLL_HEIGHT_BREAKPOINT = 920;
export const MAX_HEIGHT_OPTIONS = {
  FULL_HEIGHT: 'full-height',
  AUTO: 'auto'
};
export const DESC = 'DESC';
export const SELECTION_MODES = {
  ALL: 'all',
  PARTIAL: 'partial',
  NONE: 'none',
  ALL_ON_PAGE: 'all-on-page'
};
export const DEFAULT_VIEW_IDS = {
  ALL_FORMS: '-36',
  FORMS_WITH_SUBMISSIONS: '-37',
  PUBLISHED: '-38',
  NON_HUBSPOT: '-39'
};
export const DEFAULT_VIEW_LABELS = {
  ALL_FORMS: 'all_forms',
  FORMS_WITH_SUBMISSIONS: 'forms_with_submissions',
  PUBLISHED: 'published_forms',
  NON_HUBSPOT: 'non_hubspot_forms'
};
export const FOLDER_URL = 'folders';
export const VIEW_NAMESPACE = 'FORMS';
export const FILTER_GROUPS_MAP = {
  '0-28': [{
    filters: [{
      operator: 'IN',
      property: 'hs_form_type',
      values: ['CAPTURED', 'HUBSPOT', 'FLOW', 'BLOG_COMMENT']
    }]
  }],
  '0-105': []
};
export const DEFAULT_FRAMEWORK_TABLE_QUERY = {
  associationPreviews: {},
  count: 25,
  filterGroups: [{
    filters: [{
      operator: 'IN',
      property: 'hs_form_type',
      values: ['CAPTURED', 'HUBSPOT', 'FLOW', 'BLOG_COMMENT']
    }]
  }],
  objectTypeId: FORM_OBJECT_TYPE,
  offset: 0,
  query: '',
  requestOptions: {
    allPropertiesFetchMode: 'latest_version',
    includeAllProperties: true
  },
  sorts: [{
    order: 'DESC',
    property: 'hs_updated_at'
  }]
};